import { ExportAPI } from './ExportAPI.js';
import { RegisterAPI } from './RegisterAPI.js';
import {
  getCountUsersByFilter,
  subscribeCountUsersByFilter,
  subscribeUsersByFilter,
  subscribeUsersByFilterExport,
} from './subscribeUsersByFilter.js';

export namespace UserAPI {
  export const subscribeByFilter = subscribeUsersByFilter;
  export const subscribeByFilterExport = subscribeUsersByFilterExport;
  export const subscribeCountByFilter = subscribeCountUsersByFilter;
  export const getCountByFilter = getCountUsersByFilter;

  export const exports = ExportAPI;
  export const register = RegisterAPI;
}
